import http from "@/http";
import {message} from "ant-design-vue";
import axios from "axios";

// 领奖信息保存接口
export async function claimPrize(params) {
    try {
        const response = await http.post('/api/claim-prize/commit', params);
        console.log(response)
        if (response.data.code === 200) {
            message.success('Prize Claim Information Submitted');
        } else {
            message.error(response.data.msg);
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        // throw error;
        message.error('network error');
    }
}

export async function claimHistory(params) {
    try {
        const response = await http.post('/api/claim-prize/history', params);
        console.log(response)
        if (response.data.code === 200) {
            //message.success('Prize Claim Information Submitted');
        } else {
            message.error(response.data.msg);
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        // throw error;
        message.error('network error');
    }
}


export async function claimDetail(params) {
    try {
        const response = await http.get('/api/claim-prize/detail', {params: params});
        console.log(response)
        if (response.data.code === 200) {
            //message.success('Prize Claim Information Submitted');
        } else {
            message.error(response.data.msg);
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        // throw error;
        message.error('network error');
    }
}
